<spinner [selfSpin]="spinner" [center]="true" size="la-2x" color="grey" type="ball-triangle-path"></spinner>
<div>
            <!-- embedin pricing page -->
            <div
                *ngIf="pricingEmbbedMap.sanitizedUrl && !isPurchased">
                <br>
                <div fxLayout="row">
                    <div fxFlex="10"></div>
                    <div fxFlex="80">
                        <h2> Please purchase a plan or start a free trial to continue.
                        </h2>
                        <h3> You can cancel at any time. </h3>
                    </div>
                    <div fxFlex="10"></div>
                </div>
                <div fxLayout="row">
                    <div fxFlex="10"></div>
                    <div fxFlex="80">
                        <iframe [src]="pricingEmbbedMap.sanitizedUrl" width="100%" height="1000px"></iframe>
                    </div>
                    <div fxFlex="10"></div>
                </div>

            </div>
        <div *ngIf="isPurchased">
                You have successfully purchased the plan. Thank you. This window will close automatically.
        </div>
</div>